import type { AnyAction } from "redux";
import type { Epic } from "redux-observable";

import { filter, ignoreElements, tap } from "~/tools/rxjs";

import { typedStream } from "../../../generic/redux/TypedRedux";
import type { SetUiConfig } from "../config/ConfigActions";
import { SET_UI_CONFIG } from "../config/ConfigActionTypes";
import { isTrackingPendo } from "../config/ConfigSelectors";
import type { RootState } from "../RootState";

// Pendo IO script

const PENDO_IO_SCRIPT = `
(function(apiKey){
  (function(p,e,n,d,o){var v,w,x,y,z;o=p[d]=p[d]||{};o._q=o._q||[];
  v=['initialize','identify','updateOptions','pageLoad','track'];for(w=0,x=v.length;w<x;++w)(function(m){
      o[m]=o[m]||function(){o._q[m===v[0]?'unshift':'push']([m].concat([].slice.call(arguments,0)));};})(v[w]);
      y=e.createElement(n);y.async=!0;y.src='https://cdn.pendo.io/agent/static/'+apiKey+'/pendo.js';
      z=e.getElementsByTagName(n)[0];z.parentNode.insertBefore(y,z);})(window,document,'script','pendo');
      // Call this whenever information about your visitors becomes available
      // Please use Strings, Numbers, or Bools for value types.
      pendo.initialize({
          visitor: {
              id:              'VISITOR-UNIQUE-ID'   // Required if user is logged in
              // email:        // Recommended if using Pendo Feedback, or NPS Email
              // full_name:    // Recommended if using Pendo Feedback
              // role:         // Optional
              // You can add any additional visitor level key-values here,
              // as long as it's not one of the above reserved names.
          },
          account: {
              id:           'ACCOUNT-UNIQUE-ID' // Highly recommended
              // name:         // Optional
              // is_paying:    // Recommended if using Pendo Feedback
              // monthly_value:// Recommended if using Pendo Feedback
              // planLevel:    // Optional
              // planPrice:    // Optional
              // creationDate: // Optional
              // You can add any additional account level key-values here,
              // as long as it's not one of the above reserved names.
          }
      });
})('b953d4df-02cc-45a8-712d-7010c5643d13');
`;

export const UsageTrackPendoIOEpic: Epic<AnyAction, AnyAction, RootState> = (actions, states) =>
	actions.pipe(
		typedStream<SetUiConfig>(SET_UI_CONFIG),
		filter(() => isTrackingPendo(states.value)),
		tap(() => {
			// Attach PendoIO tracking script asynchronously
			const scriptElement = document.createElement("script");
			scriptElement.text = PENDO_IO_SCRIPT;
			document.head.appendChild(scriptElement);
		}),
		ignoreElements(),
	);
